<template>
  <div class="bodyBox">
    <div class="conceal" @click="playViedio"></div>
    <div class="swiper-container swiper-container1">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="nav of effectiveSwiperList" :key="nav.id">
          <img style @click="goToWhere(nav.id)" :src="nav.imgUrl" class="nav_item_img" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  props: {
    swiperList: {
      type: Array,
      default: () => [] // 允许为空数组
    }
  },
  data() {
    return {
      defaultSwiperList: [
        {
          imgUrl:
            "https://deiyustatic.oss-cn-beijing.aliyuncs.com/hhlianou/banner2.png",
          id: 1
        },
        {
          imgUrl:
            "https://deiyustatic.oss-cn-beijing.aliyuncs.com/hhlianou/banner4.png",
          id: 2
        },
        {
          imgUrl:
            "https://deiyustatic.oss-cn-beijing.aliyuncs.com/hhlianou/banner1.png",
          id: 3
        },
        {
          imgUrl:
            "https://deiyustatic.oss-cn-beijing.aliyuncs.com/hhlianou/banner3.png",
          id: 4
        }
      ]
    };
  },
  computed: {
    effectiveSwiperList() {
      return this.swiperList.length ? this.swiperList : this.defaultSwiperList;
    }
  },
  methods: {
    playViedio() {
      this.$router.push({ path: "/video" });
    },
    getSwiper() {
      this.swiper = new Swiper(".swiper-container1", {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      });
    },
    goToWhere(index) {
      if (this.$route.path === "/home") {
        this.$store.commit("changeHeaderActive", index + 1);
        if (index === 1) {
          this.$router.push("/planBase");
        } else if (index === 2) {
          this.$router.push("/prefPro");
        } else if (index === 3) {
          this.$router.push("/platSup");
        } else if (index === 4) {
          this.$router.push("/supSer");
        }
      }
    }
  },
  mounted() {
    this.getSwiper();
  }
};
</script>

<style lang="less" scoped>
::v-deep .swiper-pagination-bullet {
  background: #fff;
  opacity: 0.5;
  width: 6vw;
  height: 1.3vh;
  border-radius: 1.3vh;
}

::v-deep .swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  margin: 0 0 2vh -30vw;
}

::v-deep .swiper-pagination-bullet-active {
  background: rgb(14, 174, 91);
  /* 激活状态的分页器点的背景颜色 */
  opacity: 1;
  /* 激活状态的分页器点的透明度 */
  width: 6vw;
  height: 1.3vh;
}

.swiper-container1 {
  width: 100%;
  height: 60vh;
}

.bodyBox {
  width: 100%;
  height: 59vh;
  padding-top: 12.5vh;
  position: relative;
}

.conceal {
  position: absolute;
  top: 40vh;
  right: 19vw;
  color: #fff;
  z-index: 10000;
  cursor: pointer;
  width: 5vw;
  height: 7vh;
  background: transparent;
}

.nav_item_img {
  width: 100%;
  height: 100%;
  // object-fit: cover;
  cursor: pointer;
}

@media screen and (max-width: 599px) {
  ::v-deep .swiper-pagination-bullet {
    background: #fff;
    opacity: 0.5;
    width: 10px;
    height: 10px;
    border-radius: 1.3vh;
  }

  ::v-deep .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    margin: 0 0 2vh -30vw;
  }

  ::v-deep .swiper-pagination-bullet-active {
    background: rgb(14, 174, 91);
    /* 激活状态的分页器点的背景颜色 */
    opacity: 1;
    /* 激活状态的分页器点的透明度 */
    width: 10px;
    height: 10px;
  }

  .swiper-container1 {
    width: 100%;
    height: 150px;
  }

  .bodyBox {
    width: 100%;
    height: 20vh;
    padding-top: 10.5vh;
    position: relative;
  }

  .conceal {
    position: absolute;
    top: 20vh;
    right: 19vw;
    color: #fff;
    z-index: 10000;
    cursor: pointer;
    width: 5vw;
    height: 7vh;
    background: transparent;
  }

  .nav_item_img {
    width: 100%;
    height: 20vh;
    // object-fit: cover;
    cursor: pointer;
  }
}
</style>
